import comp from "./SubjectJournalCard";
export default comp;
